import { graphql } from "../gql";

export const setClaimStageMutationDoc = graphql(`
  mutation setClaimStage($input: SetClaimStageInput!) {
    setClaimStage(input: $input) {
      batchClaimStateById {
        id
        stage {
          description
          id
          labelOrder
          name
          type
        }
      }
      id
    }
  }
`);
